import { useMemo } from "react";
import { getChannelList } from "utils/api";
import { useAsyncLoader } from "../../useAsyncLoader";

export default function useChannels() {
  const { data: channels, isLoading: channelsAreLoading, error } = useAsyncLoader(getChannelList);
  const c = useMemo(() => (channels ? channels : []), [channels]);
  return [c, channelsAreLoading];
}
